import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { SmoothScroll } from "@/components/SmoothScroll";
import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";
import { PageWipe } from "@/components/PageWipe";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Story from "@/pages/Story";
import Menu from "@/pages/Menu";
import Contact from "@/pages/Contact";

function App() {
  return (
    <div className="App bg-charcoal">
      <BrowserRouter>
        <SmoothScroll>
          <PageWipe />
          <Toaster position="bottom-right" />
          <Nav />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/story" element={<Story />} />
            <Route path="/menu" element={<Menu />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
          <Footer />
        </SmoothScroll>
      </BrowserRouter>
    </div>
  );
}

export default App;
